import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import s from './WorkTracker.module.scss';
import { taskShape } from './propTypes';
import { formatDateTime } from './lib/dates';
import { BubbleIcon } from './icons';

// The comment box stays hidden until the bubble is pressed; existing comments
// always show.
export default function Comments({
  task, onAdd, onDelete, onDirty,
}) {
  const [draft, setDraft] = useState('');
  const [writing, setWriting] = useState(false);
  const inputRef = useRef(null);
  useEffect(() => { if (onDirty) onDirty(draft.trim().length > 0); }, [onDirty, draft]);
  useEffect(() => { if (writing) inputRef.current?.focus(); }, [writing]);
  const comments = task.comments || [];
  const post = async () => {
    const body = draft.trim();
    if (!body) return;
    if (await onAdd(body)) setDraft('');
  };
  return (
    <div className={s.section}>
      <div className={s.labelRow}>
        <h3 className={s.sectionTitle} style={{ margin: 0 }}>Comments</h3>
        <button
          type="button"
          className={s.iconEdit}
          aria-label="Write a comment"
          title="Write a comment"
          aria-expanded={writing}
          onClick={() => setWriting((w) => !w)}
        >
          <BubbleIcon />
        </button>
      </div>
      {comments.length === 0 && <p className={s.notice} style={{ margin: '0 0 8px' }}>No comments yet.</p>}
      {comments.map((c) => (
        <div key={c.id} className={s.comment}>
          <div className={s.commentMeta}>
            <span className={s.commentAuthor}>{c.author || 'Someone'}</span>
            <span>{formatDateTime(c.created_at)}</span>
            <span className={s.spacer} />
            <button type="button" className={s.x} aria-label="Delete comment" onClick={() => onDelete(c)}>×</button>
          </div>
          <p className={s.commentBody}>{c.body}</p>
        </div>
      ))}
      {writing && (
      <div style={{ marginTop: 8 }}>
        <input
          ref={inputRef}
          className={s.input}
          style={{ width: '100%' }}
          value={draft}
          placeholder="Write a comment"
          aria-label="New comment"
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); post(); } }}
        />
        <button type="button" className={s.btn} style={{ marginTop: 8 }} onClick={post}>Comment</button>
      </div>
      )}
    </div>
  );
}

Comments.propTypes = {
  task: taskShape.isRequired,
  onAdd: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onDirty: PropTypes.func,
};
Comments.defaultProps = { onDirty: undefined };
